import { DurationDropdownOptions, JobAmountSummaryAttributes } from '../types';
import { CashIcon, CheckIcon, DirectTransferIcon, OtherPaymentIcon, ZelleIcon } from 'assets/icons';

export enum SalesDetailsTypes {
  BY_TEAM_MEMBERS = 'team_members',
  BY_PAYMENT_METHODS = 'payment_methods'
}

export enum ManualPaymentMethodKeys {
  CASH = 'm-cash',
  CHECK = 'm-check',
  DIRECT_TRANSFER = 'm-direct-transfer',
  ZELLE = 'm-zelle',
  OTHER = 'm-other'
}

export enum ManualPaymentMethodValues {
  CASH = 'Cash',
  CHECK = 'Check',
  DIRECT_TRANSFER = 'Direct Transfer',
  ZELLE = 'Zelle',
  OTHER = 'Other payment'
}

export const ManualPaymentMethods = [
  {
    key: ManualPaymentMethodKeys.CASH,
    value: ManualPaymentMethodValues.CASH,
    icon: CashIcon
  },
  {
    key: ManualPaymentMethodKeys.CHECK,
    value: ManualPaymentMethodValues.CHECK,
    icon: CheckIcon
  },
  {
    key: ManualPaymentMethodKeys.ZELLE,
    value: ManualPaymentMethodValues.ZELLE,
    icon: ZelleIcon
  },
  {
    key: ManualPaymentMethodKeys.DIRECT_TRANSFER,
    value: ManualPaymentMethodValues.DIRECT_TRANSFER,
    icon: DirectTransferIcon
  },
  {
    key: ManualPaymentMethodKeys.OTHER,
    value: ManualPaymentMethodValues.OTHER,
    icon: OtherPaymentIcon
  }
];

export enum PaymentMethodFilterKeys {
  ACH = 'ach',
  AFFIRM = 'affirm',
  AFTERPAY = 'afterpay',
  APPLEPAY = 'applepay',
  CARD = 'card',
  GPAY = 'gpay',
  KLARNA = 'klarna',
  MANUAL_CASH = 'm-cash',
  MANUAL_CHECK = 'm-check',
  MANUAL_DIRECT_TRANSFER = 'm-direct-transfer',
  MANUAL_OTHER = 'm-other',
  MANUAL_ZELLE = 'm-zelle',
  SUNBIT = 'sunbit',
  CHECK_DEPOSIT = 'check-deposit',
  TTP = 'ttp'
}

export const PaymentMethodsForInvoiceFilter = [
  {
    key: PaymentMethodFilterKeys.ACH,
    value: 'ACH'
  },
  {
    key: PaymentMethodFilterKeys.AFFIRM,
    value: 'Affirm'
  },
  {
    key: PaymentMethodFilterKeys.AFTERPAY,
    value: 'Afterpay'
  },
  {
    key: PaymentMethodFilterKeys.APPLEPAY,
    value: 'Apple Pay'
  },
  {
    key: PaymentMethodFilterKeys.CARD,
    value: 'Credit / Debit Card'
  },
  {
    key: PaymentMethodFilterKeys.GPAY,
    value: 'Google Pay'
  },
  {
    key: PaymentMethodFilterKeys.KLARNA,
    value: 'Klarna'
  },
  {
    key: PaymentMethodFilterKeys.MANUAL_CASH,
    value: 'Manual-Cash'
  },
  {
    key: PaymentMethodFilterKeys.MANUAL_CHECK,
    value: 'Manual-Check'
  },
  {
    key: PaymentMethodFilterKeys.MANUAL_DIRECT_TRANSFER,
    value: 'Manual-Direct Transfer'
  },
  {
    key: PaymentMethodFilterKeys.MANUAL_OTHER,
    value: 'Manual-Other'
  },
  {
    key: PaymentMethodFilterKeys.MANUAL_ZELLE,
    value: 'Manual-Zelle'
  },
  {
    key: PaymentMethodFilterKeys.SUNBIT,
    value: 'Sunbit'
  }
];

export const TipInvoiceFilter = [
  {
    key: 'tip',
    value: 'Only with Tips'
  }
];

export const timelineFilterOptions = [
  { name: DurationDropdownOptions.TODAY },
  { name: DurationDropdownOptions.THIS_MONTH },
  { name: DurationDropdownOptions.LAST_MONTH },
  { name: DurationDropdownOptions.THIS_YEAR }
];

export const jobAmountFilterOptions = [
  { name: 'Jobs created', value: JobAmountSummaryAttributes.CREATED_AT },
  { name: 'Jobs scheduled', value: JobAmountSummaryAttributes.SCHEDULED_FROM }
];

export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=tech.scanpay.merchant&hl=en_IN&gl=US';
export const APP_STORE_URL = 'https://apps.apple.com/sg/app/scanpay-accept-payments/id1572936786';

export const validEmailRegex = new RegExp('^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$');
export const validPhoneNumberRegex = new RegExp('^(\\+\\d{1,2}\\s)?\\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4}$');
